import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { PainSection } from './sections/PainSection';
import { ComparisonSection } from './sections/ComparisonSection';
import { MechanismSection } from './sections/MechanismSection';
import { CreatorSection } from './sections/CreatorSection';
import { ProductSection } from './sections/ProductSection';
import { PriceSection } from './sections/PriceSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { GuaranteeSection } from './sections/GuaranteeSection';
import { FinalCtaSection } from './sections/FinalCtaSection';
export function App() {
  return <main className="w-full min-h-screen bg-midnight text-warmwhite overflow-x-hidden selection:bg-rosegold/30 selection:text-warmwhite" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ComparisonSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <CreatorSection data-id="element-5" />
      <ProductSection data-id="element-6" />
      <PriceSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <FinalCtaSection data-id="element-10" />
    </main>;
}